(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients-dynamic"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    let trigger = document.querySelector('.popup-trigger');
    let popup = document.getElementById('popup');
    let closeBtn = document.getElementById('popupClose');

    trigger.addEventListener('click', function() {
        popup.style.display = 'block';
    });

    closeBtn.addEventListener('click', function() {
        popup.style.display = 'none';
    });

    window.addEventListener('click', function(event) {
        if (event.target == popup) {
            popup.style.display = 'none';
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    let trigger = document.querySelector('.popup-trigger');
    let popup = document.getElementById('popup');
    let closeBtn = document.getElementById('popupClose');

    trigger.addEventListener('click', function() {
        popup.style.display = 'block';
    });

    closeBtn.addEventListener('click', function() {
        popup.style.display = 'none';
    });

    window.addEventListener('click', function(event) {
        if (event.target == popup) {
            popup.style.display = 'none';
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
